import { Typography } from '@breetometer/components';
import { InfoIcon } from 'BreetAssets';
import { Tooltip, TooltipContent } from 'BreetComponents';
import { type IBusiness, type ILoginError, showToast } from 'BreetHelpers';
import { useLoginApi, useModalApi } from 'BreetHooks';
import { selectCredentials, selectLogin, useAppSelector } from 'BreetRedux';
import { useCallback, useState } from 'react';

import AvailableAccount from './AvailableAccount';

const Child = () => {
	const loginData = useAppSelector(selectLogin);

	const errorData = loginData.error as ILoginError | undefined;

	const [businesses] = useState<IBusiness[]>(errorData?.data.data.businesses ?? []);

	const credentials = useAppSelector(selectCredentials);

	const [selectedId, setSelectedId] = useState<string>('');

	const { isLoading, loginUser } = useLoginApi();

	const { handleModalClose } = useModalApi();

	const switchUserAccount = useCallback(
		(businessIdArg: string) => () => {
			if (!credentials?.email || !credentials.password) {
				showToast('error', 'Something went wrong');
				return;
			}

			setSelectedId(businessIdArg);

			loginUser({
				email: credentials.email,
				password: credentials.password,
				businessId: businessIdArg,
				onFinalCallback: handleModalClose('switchUserAccount'),
			});
		},
		[credentials?.email, credentials?.password, handleModalClose, loginUser]
	);

	return (
		<div className='available-accounts bg-primary-500'>
			<div className='header'>
				<div className='header-txt'>
					<Typography
						as='h4'
						className='color-neutral-50'
					>
						Available Accounts
					</Typography>
					<Tooltip
						tipElement={<TooltipContent content="These are the business accounts where you've been added as a team member." />}
					>
						<InfoIcon className='info-icon svg-dark' />
					</Tooltip>
				</div>
				<Typography className='color-primary-100'>Select a business account to continue.</Typography>
			</div>
			<div className='list'>
				{businesses.map((business, index) => (
					<AvailableAccount
						accountName={business.name}
						accountRole={business.role}
						onClick={switchUserAccount(business.id)}
						key={business.id}
						isLoading={selectedId === business.id && isLoading}
						lastChild={index === businesses.length - 1}
						websiteUrl={business.websiteUrl}
					/>
				))}
			</div>
		</div>
	);
};

export default Child;
